import React, { useState, useEffect } from "react";
import { Check, Plus } from "lucide-react";
import { useAuth } from "../AuthContext";
import { API_URL } from "../config";

export default function SubscribeButton({ author, onLoginRequest }) {
  const { isLoggedIn, token } = useAuth();
  const [subscribed, setSubscribed] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!author) return;
    const headers = token ? { Authorization: `Bearer ${token}` } : {};
    fetch(`${API_URL}/subscriptions/status?author=${encodeURIComponent(author)}`, { headers })
      .then(r => r.ok ? r.json() : { subscribed: false })
      .then(d => setSubscribed(d.subscribed))
      .catch(() => {});
  }, [author, token]);

  if (!author) return null;

  const toggle = async () => {
    if (!isLoggedIn) { onLoginRequest && onLoginRequest(); return; }
    setBusy(true);
    try {
      const r = await fetch(`${API_URL}/subscriptions/toggle`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        body: JSON.stringify({ author }),
      });
      if (r.ok) {
        const d = await r.json();
        setSubscribed(d.subscribed);
      }
    } finally {
      setBusy(false);
    }
  };

  return (
    <button onClick={toggle} disabled={busy} style={{
      display: "inline-flex", alignItems: "center", gap: 6,
      background: subscribed ? "#e0f2ea" : "#f0f2f8", color: subscribed ? "#15803d" : "#555",
      border: subscribed ? "1px solid #15803d" : "1px solid transparent",
      borderRadius: 8, padding: "6px 14px", fontSize: "0.9rem",
      fontWeight: 600, cursor: "pointer",
    }}>
      {subscribed
        ? <><Check size={14} strokeWidth={2.4} /> Подписан на {author}</>
        : <><Plus size={14} strokeWidth={2.4} /> Подписаться на {author}</>}
    </button>
  );
}
